export const YoutubeColored = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_11_243)">
      <path
        d="M21.6017 7.38457C21.4886 6.95908 21.2657 6.57075 20.9554 6.25845C20.6451 5.94615 20.2582 5.72082 19.8335 5.60502C18.2698 5.18457 12.0198 5.18457 12.0198 5.18457C12.0198 5.18457 5.76984 5.18457 4.2062 5.60502C3.78144 5.72082 3.39455 5.94615 3.08424 6.25845C2.77393 6.57075 2.55109 6.95908 2.43802 7.38457C2.01984 8.95502 2.01984 12.23 2.01984 12.23C2.01984 12.23 2.01984 15.505 2.43802 17.0755C2.55109 17.501 2.77393 17.8893 3.08424 18.2016C3.39455 18.5139 3.78144 18.7392 4.2062 18.855C5.76984 19.2755 12.0198 19.2755 12.0198 19.2755C12.0198 19.2755 18.2698 19.2755 19.8335 18.855C20.2582 18.7392 20.6451 18.5139 20.9554 18.2016C21.2657 17.8893 21.4886 17.501 21.6017 17.0755C22.0198 15.505 22.0198 12.23 22.0198 12.23C22.0198 12.23 22.0198 8.95502 21.6017 7.38457Z"
        fill="#FF0302"
      />
      <path
        d="M9.9744 15.2041V9.25635L15.2017 12.2302L9.9744 15.2041Z"
        fill="#FEFEFE"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_243">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(2 2.22998)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default YoutubeColored;
